<template>
  <DialogLayout class="flow-record-me"
                title="我发起的详情"
                v-loading="loading"
                element-loading-text="数据加载中，请稍等...">
    <template v-if="recordInfo">
      <div class="me-main">

        <!-- 滚动内容区域 -->
        <AppScrollbar class="me-scroll">
          <div class="me-content">

            <!-- 流程信息卡片 -->
            <div class="me-section">
              <div class="section-header">
                <span class="section-title theme-text">{{ approvalInfo.processDefinitionName }}</span>
                <div class="section-header-tags">
                  <el-tag v-if="approvalInfo.ended" size="mini" type="info">已结束</el-tag>
                  <el-tag v-else size="mini" type="success">启用中</el-tag>
                </div>
              </div>
              <div class="section-body section-body-info">
                <div v-if="approvalInfo.flowNo" class="info-row">
                  <span class="info-label">流水号</span>
                  <span class="info-value">{{ approvalInfo.flowNo || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">发起人</span>
                  <span class="info-value">{{ approvalInfo.startUser || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">提交时间</span>
                  <span class="info-value">{{ approvalInfo.startTime || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">当前节点</span>
                  <span class="info-value">{{ approvalInfo.currentActivityName || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">审批状态</span>
                  <span class="info-value">
                    <el-tag v-if="approvalInfo.bizStatus" size="mini" :type="bizStatusTagType">{{ approvalInfo.bizStatus.name }}</el-tag>
                    <span v-else>-</span>
                  </span>
                </div>
              </div>
            </div>

            <!-- 审批详情卡片 -->
            <div class="me-section">
              <div class="section-header">
                <span class="section-title theme-text">审批详情</span>
                <el-button type="text" size="mini" @click="formExpanded = !formExpanded">
                  <i :class="formExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                  {{ formExpanded ? '折叠' : '展开' }}
                </el-button>
              </div>
              <el-collapse-transition>
                <div v-show="formExpanded" class="section-body">
                  <FlowCommonApprovalForm :form-info="formInfo"></FlowCommonApprovalForm>
                </div>
              </el-collapse-transition>
            </div>

            <!-- 流程记录卡片 -->
            <div class="me-section">
              <div class="section-header">
                <span class="section-title theme-text">流程记录</span>
              </div>
              <div class="section-body section-body-history">
                <FlowCommonHistory v-if="historyInfo"
                                   :history-info="historyInfo"
                                   :timeline="true"></FlowCommonHistory>
                <div v-else class="empty-hint">暂无流程记录</div>
              </div>
            </div>

          </div>
        </AppScrollbar>

        <!-- 底部操作栏 -->
        <ActionGroup class="me-actions">
          <template v-if="!approvalInfo.ended">
            <ActionItem v-if="approvalInfo.canUrge">
              <el-button type="text" size="small" icon="el-icon-bell" @click="handleUrge">催办</el-button>
            </ActionItem>
            <ActionItem v-if="approvalInfo.canComment">
              <el-button type="text" size="small" icon="el-icon-chat-line-round" @click="handleComment">评论</el-button>
            </ActionItem>
          </template>
          <template slot="empty">
            <span v-if="approvalInfo.ended" class="flow-ended-text"><i class="el-icon-circle-check"></i><span>流程已结束，相关审批任务已完成</span></span>
            <span v-else class="flow-ended-text"><i class="el-icon-warning-outline"></i><span>暂无可用操作</span></span>
          </template>
        </ActionGroup>

      </div>
    </template>
    <template v-else-if="!loading">
      <Hint type="error">
        <div>流程数据加载失败</div>
        <el-button size="mini" type="text" @click="loadDetailInfo">重新加载</el-button>
      </Hint>
    </template>

    <!-- 催办弹窗 -->
    <DataGridDialog title="流程催办" :visible.sync="urgeDialog.visible" width="500px"
                    custom-class="flow-record-me-urge-dialog" :close-on-click-modal="false">
      <div class="urge-content">
        <el-form label-position="top" size="small">
          <el-form-item label="备注信息">
            <el-input v-model="urgeDialog.comment" type="textarea" :rows="3"
                      :maxlength="200" show-word-limit placeholder="请输入备注信息"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="urgeDialog.visible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="urgeDialog.submitting" @click="confirmUrge">确定催办</el-button>
      </div>
    </DataGridDialog>

    <!-- 评论弹窗 -->
    <DataGridDialog title="添加评论" :visible.sync="commentDialog.visible" width="500px"
                    custom-class="flow-record-me-comment-dialog" :close-on-click-modal="false">
      <div class="comment-content">
        <FlowApprovalForm ref="commentForm" comment-label="评论内容" :comment-required="true"
                          comment-placeholder="请输入评论内容"></FlowApprovalForm>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="commentDialog.visible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="commentDialog.submitting" @click="confirmComment">确定评论</el-button>
      </div>
    </DataGridDialog>

  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../widgets/DialogLayout'
import AppScrollbar from '../../../../elements/AppScrollbar'
import FlowCommonApprovalForm from '../../common/approval/form'
import FlowCommonHistory from '../../common/approval/history'
import Hint from '../../../../elements/Hint'
import DataGridDialog from '../../../../elements/grid/DataGridDialog'
import FlowApprovalForm from '../../../../elements/flow/approval/FlowApprovalForm'
import ActionGroup from '../../../../widgets/action-group/ActionGroup'
import ActionItem from '../../../../widgets/action-group/ActionItem'

export default {
  name: 'FlowRecordMe',
  components: {
    DialogLayout,
    AppScrollbar,
    Hint,
    DataGridDialog,
    FlowApprovalForm,
    ActionGroup,
    ActionItem,
    FlowCommonHistory,
    FlowCommonApprovalForm
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      recordInfo: null,
      formExpanded: true,
      urgeDialog: {
        visible: false,
        submitting: false,
        comment: ''
      },
      commentDialog: {
        visible: false,
        submitting: false
      }
    }
  },
  computed: {
    approvalInfo () {
      return (this.recordInfo && this.recordInfo.approval) || {}
    },
    formInfo () {
      return this.recordInfo && this.recordInfo.form
    },
    historyInfo () {
      return this.recordInfo && this.recordInfo.process
    },
    bizStatusTagType () {
      const bizStatus = this.approvalInfo && this.approvalInfo.bizStatus
      if (bizStatus) {
        switch (bizStatus.code) {
          case '1': return 'primary'
          case '2': return 'info'
          case '3': return 'danger'
          case '4': return 'success'
          default: break
        }
      }
      return 'info'
    }
  },
  methods: {
    loadDetailInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/flow/record/me/process/record',
        method: 'post',
        data: this.$qs.stringify({
          id: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.recordInfo = response.data.recordInfo || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleUrge () {
      this.urgeDialog.visible = true
      this.urgeDialog.submitting = false
      this.urgeDialog.comment = ''
    },
    confirmUrge () {
      this.$confirm('确定要催办此流程吗？', '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.urgeDialog.submitting = true
        this.$ajax({
          url: '/workspace/manager/flow/record/me/process/urge',
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          data: {
            id: this.rowData.id,
            comment: this.urgeDialog.comment
          }
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'] || '催办成功')
                this.urgeDialog.visible = false
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.urgeDialog.submitting = false
        })
      }).catch(() => {})
    },
    handleComment () {
      this.commentDialog.visible = true
      this.commentDialog.submitting = false
      this.$nextTick(() => {
        if (this.$refs.commentForm) {
          this.$refs.commentForm.reset()
        }
      })
    },
    confirmComment () {
      this.$refs.commentForm.validate().then(formData => {
        this.$confirm('确定要提交评论吗？', '确认提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.commentDialog.submitting = true
          this.$ajax({
            url: '/workspace/manager/flow/record/me/process/comment',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: this.$extend({
              id: this.rowData.id
            }, formData)
          }).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'] || '评论成功')
                  this.commentDialog.visible = false
                  this.loadDetailInfo()
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.commentDialog.submitting = false
          })
        }).catch(() => {})
      }).catch(err => {
        this.$message.warning(err.message)
      })
    }
  },
  mounted () {
    this.loadDetailInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadDetailInfo()
      }
    }
  }
}
</script>

<style lang="scss">
.flow-record-me {
  height: 100%;
  width: 760px;
  max-width: 100%;

  .me-main {
    height: 100%;
    display: flex;
    flex-direction: column;

    .me-scroll {
      flex: 1;
      overflow: hidden;
    }

    .me-content {
      padding: 12px;

      .me-section {
        background-color: #fff;
        border-radius: 8px;
        margin-bottom: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        overflow: hidden;

        &:last-child {
          margin-bottom: 0;
        }

        .section-header {
          padding: 12px 15px;
          border-bottom: 1px solid #ebeef5;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .section-title {
            font-size: 13px;
            font-weight: 500;
          }

          .section-header-tags {
            display: flex;
            align-items: center;
            gap: 6px;
          }
        }

        .section-body {
          .empty-hint {
            text-align: center;
            color: #909399;
            font-size: 13px;
            padding: 16px 0;
          }
        }

        .section-body-info {
          padding: 12px 15px;

          .info-row {
            display: flex;
            align-items: center;
            font-size: 12px;
            padding: 5px 0;

            .info-label {
              flex: none;
              width: 70px;
              color: #909399;
            }

            .info-value {
              flex: 1;
              color: #303133;
              min-width: 0;
            }
          }
        }

        .section-body-history {
          padding: 16px 20px;
        }
      }
    }

    .me-actions {
      flex: none;
      min-height: 54px;
      padding: 10px 15px;
      background-color: #fff;
      border-top: 1px solid #ebeef5;

      .flow-ended-text {
        display: flex;
        align-items: baseline;
        font-size: 12px;
        color: #909399;

        i {
          margin-right: 4px;
          font-size: 13px;
        }
      }
    }
  }
}

.flow-record-me-urge-dialog {
  .urge-content {
    padding: 15px 20px;

    .el-form-item {
      &:last-child {
        margin-bottom: 0;
      }

      .el-form-item__label {
        padding-bottom: 5px;
        line-height: 1.5;
      }
    }

    .el-textarea__inner {
      resize: none;
    }
  }

  .dialog-footer {
    text-align: right;
  }
}

.flow-record-me-comment-dialog {
  .comment-content {
    padding: 15px 20px;
  }

  .dialog-footer {
    text-align: right;
  }
}
</style>
